import { WINDOW_RESIZE } from 'FRONTEND/actions/constants';
import {
  extendRightPanel,
  reduceRightPanel,
  joinConfRoom,
  endVideoConference,
} from 'FRONTEND/reducers/rightPanelSlice';
import { RTC_IFRAME_ID, SCREEN_XS_PX } from 'LEGACY/constants';

const videoconferenceMiddleware = (store) => (next) => (action) => {
  const rtcIframe = document.getElementById(RTC_IFRAME_ID);
  const rightPanel = document.getElementById('rightPanel-container');
  switch (action.type) {
    case WINDOW_RESIZE: {
      next(action);
      const screenXS = window.matchMedia(`(max-width: ${SCREEN_XS_PX})`).matches;
      if (rtcIframe) {
        if (screenXS) {
          rtcIframe.contentWindow.postMessage({
            type: 'use_vertical_layout',
          }, '*');
        } else {
          rtcIframe.contentWindow.postMessage({
            type: 'use_horizontal_layout',
          }, '*');
        }
      }
      return;
    }

    case extendRightPanel.toString():
    case joinConfRoom.toString():
      next(action);
      if (rightPanel) {
        $('select.select2-hidden-accessible').select2('close');
      }
      return;

    case reduceRightPanel.toString():
    case endVideoConference.toString():
      next(action);
      if (rightPanel) {
        $('select.select2-hidden-accessible').select2('close');
      }
      return;

    default:
      return next(action);
  }
};

export default videoconferenceMiddleware;
